import { APIModel } from '@shared/interfaces';

import { PollingStatus, StatusProvider } from '@/tax/models';

export enum QuestionnaireSyncType {
    SyncToSilverfin = 'SYNC_TO_SILVERFIN',
    SyncFromSilverfin = 'SYNC_FROM_SILVERFIN',
}
export class QuestionnaireSync implements APIModel {
    id = -1;
    createdAt = new Date();
    endDate?: Date;
    status = PollingStatus.Init;
    statusMessage?: string;
    statusMessageProvider?: StatusProvider;

    deserialize(data: any) {
        this.id = data.id ?? -1;
        this.createdAt = data.created_at !== null ? new Date(data.created_at) : new Date();
        this.endDate = data.end_date !== null ? new Date(data.end_date) : new Date();
        this.status = data.status ?? undefined;
        this.statusMessage = data.status_message ?? undefined;
        this.statusMessageProvider = data.status_message_provider ?? undefined;
        return this;
    }
}
